import Head from "next/head";
import Link from "next/link";
import { HeaderMeta } from "./HeaderMeta";
import MetamateLogo from "./MetamateLogo";
import { Section } from "./Section";
import { useRouter } from "next/router";
import Button from "./Button";

export default function Header({backLink="/", title, withButton=false}) {
    const router=  useRouter()

    const closeDiv = <div className="text-2xl">&#x2715;</div>;
    
    return <div className="text-black py-2">
        <HeaderMeta title={title}/>
        <Section>
            <div className="flex flex-row justify-between">
                <MetamateLogo size={3} sizeMd={3}/>
                <div className="flex flex-row gap-4 place-items-center">{withButton && <Link href="/mates"><div className={"cursor-pointer bg-accent px-4 py-2 rounded-lg text-white font-bold"}>
                      show all
                      </div></Link>}
                {backLink 
                    ? <Link href={backLink}>{closeDiv}</Link>
                    : <div className="cursor-pointer" onClick={() => { router.back(); }}>{closeDiv}</div>
                }
                </div>
            </div>
        </Section>
    </div>
}